import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class GenesysHttpInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    // Solo interceptar requests a Genesys Cloud
    if (req.url.includes('api.mypurecloud.com')) {
      console.log('Interceptando request a Genesys Cloud:', req.url);
      
      // Crear headers optimizados para Genesys Cloud
      let headers = req.headers;
      
      // Asegurar que tenemos los headers correctos
      if (!headers.has('Accept')) {
        headers = headers.set('Accept', 'application/json');
      }
      
      if (!headers.has('Content-Type') && (req.method === 'POST' || req.method === 'PUT' || req.method === 'PATCH')) {
        headers = headers.set('Content-Type', 'application/json');
      }
      
      // Crear request clonada con configuraciones optimizadas
      const genesysRequest = req.clone({
        headers: headers,
        setHeaders: {
          // Headers adicionales para evitar problemas de CORS
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      console.log('Request modificada para Genesys:', {
        url: genesysRequest.url,
        method: genesysRequest.method,
        headers: genesysRequest.headers.keys().map(key => ({ [key]: genesysRequest.headers.get(key) }))
      });
      
      return next.handle(genesysRequest);
    }
    
    // Para otras requests, pasar sin modificar
    return next.handle(req);
  }
} 